module.exports = __webpack_public_path__ + "img/fuhyo.f47992d3.png";